'use client';
import { Stack } from '@/ui/primatives';
import * as Styled from './styled';

const LayoutWrapper: React.FC<{
  controls?: React.ReactNode;
  grid: React.ReactNode;
}> = ({ controls, grid, ...rest }) => {
  return (
    <Styled.LayoutWrapper>
      <div style={{ minWidth: '100%' }}>
        <Stack gap={0} style={{ height: '100%' }}>
          {controls}
          {grid}
        </Stack>
      </div>
    </Styled.LayoutWrapper>
  );
};

export default LayoutWrapper;
